import { skipToken } from '@reduxjs/toolkit/query'
import { type Booking, type Location, MeetingMode } from '../../../models/Scheduling'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'
import {
  useGetAccountSchedulingSettingsQuery,
  useGetSchedulingLocationsQuery,
  useGetUserSchedulingLocationsQuery,
  useGetUserSchedulingSettingsQuery,
} from '../../../store/scheduling/scheduling'
import { resolveLocationPreviewId } from '../flows/form/scheduleHelpers'

export const useBookingLocation = (booking: Booking): Location | undefined => {
  const accountId = useAppSelector(selectSafeAuthenticatedUser).accountId
  const isInPerson = booking.meetingMode === MeetingMode.IN_PERSON && booking.location != null
  const accountRequest = isInPerson ? { accountId } : skipToken
  const ownerRequest = isInPerson ? { accountId, userId: booking.userId } : skipToken
  const { data: accountSettings } = useGetAccountSchedulingSettingsQuery(accountRequest)
  const { data: ownerSettings } = useGetUserSchedulingSettingsQuery(ownerRequest)
  const { data: accountLocations } = useGetSchedulingLocationsQuery(accountRequest)
  const { data: ownerLocations } = useGetUserSchedulingLocationsQuery(ownerRequest)

  if (!isInPerson) {
    return undefined
  }
  const locationId = resolveLocationPreviewId(booking.location, accountSettings?.defaults.locationId, ownerSettings?.defaults.locationId)
  return locationId != null ? [...(accountLocations ?? []), ...(ownerLocations ?? [])].find((location) => location.id === locationId) : undefined
}
